import set from "@rill/set";
import moment from "moment";
import _ from "lodash";

import VideoList from "./VideoList";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import { JWPlayerMultipleVideos } from "../../../parts/modals/jwplayer-multiple-videos";
import { FilterExerciseVideoList } from "../../../parts/modals/filter-exercise-video-list";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const VideoListController = (app) => {
  app.get(
    "/video-list",
    set("heading", "Video List"),
    async ({ req, res, load, locals, momentTZ }) => {
      const { query = {} } = req;
      const modal = query.modal || {};
      const summary = query.summary || false;

      const athleteId = locals.athlete
        ? locals.athlete._id
        : locals.activeUser._id;

      const isAllowToViewAllOrganizationsAthletes =
        locals.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin");

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }

      await load("videoListMetrics", {
        page: query.pageToShow ? parseInt(query.pageToShow) : 1,
        limit: 80, //50 exercises
        sort: -1,
        proxyAthlete: athleteId,
        to: query.toDate
          ? query.toDate
          : moment //today date but with T20:00:00Z format hour, to avoid timezones problems and for caching requests (if we request this endpoint and the seconds are changing the caching is not going to work, so we set a hardcore hour)
              .utc(moment())
              .set({
                hour: 20,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
              .format("YYYY-MM-DDTHH:mm:ss[Z]"),
        from: query.fromDate
          ? query.fromDate
          : moment //one year ago date but with T20:00:00Z format hour, to avoid timezones problems and for caching requests (if we request this endpoint and the seconds are changing the caching is not going to work, so we set a hardcore hour)
              .utc(moment().subtract(1, "year"))
              .set({
                hour: 20,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
              .format("YYYY-MM-DDTHH:mm:ss[Z]"),
      });

      let comesFromCheckInSummary = false;
      // Required conditional because this could be undefined when refreshing
      if (Boolean(summary) && req?.original?.headers?.referer) {
        comesFromCheckInSummary =
          req.original.headers.referer.includes("check-in-summary");
      }
      if (query.showBack) comesFromCheckInSummary = true;
      locals.modal = {
        "watch-video-list": (
          <JWPlayerVideoModal
            mediaId={query.mediaId}
            originalId={query.originalId}
            athleteId={query.mediaAthleteId}
            exerciseToEdit={query.exerciseToEdit}
            reviewedByTheCoach={query.reviewedByTheCoach}
            setIndex={query.setIndex}
            videoIndex={query.videoIndex}
          />
        ),
        "watch-multiple-videos-modal": (
          <JWPlayerMultipleVideos
            firstMedia={query.firstMedia}
            secondMedia={query.secondMedia}
            athlete={query.athlete}
            locals={locals}
          />
        ),
        "filter-exercise-videos-modal": (
          <FilterExerciseVideoList
            filtersModal={query.filtersModal}
            exerciseFilters={query.exerciseFilters}
          />
        ),
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = (
        <VideoList
          query={query}
          locals={locals}
          momentTZ={momentTZ}
          comesFromCheckInSummary={comesFromCheckInSummary}
        />
      );
    }
  );
};

export default VideoListController;
